<script setup lang="ts">
defineProps<{
  as?: string
}>()
</script>

<template>
  <component :is="as ?? 'div'" class="n-card n-card-base">
    <slot />
  </component>
</template>
